import { useMemo } from "react";
import { useSelector } from "react-redux";
import { enums } from "../lib";

/**
 * Use Audit is Readonly Hook
 *
 * Pending Count is editable: controllers can work an audit while the auditors
 * are still counting it. Whether they are warned about the incomplete picture is
 * a separate, organisation-level choice — see use-pending-count-warning-enabled.
 */
export default () => {
    const { auditsList } = useSelector((state) => state);

    const next = useMemo(() => {
        const audit = auditsList?.item;
        if (audit && audit.status != null) {
            const status = audit.status.id ?? audit.status;
            return (
                status === enums.status.audit.awaitingDownload ||
                status === enums.status.audit.closed
            );
        }
        return null;
    }, [auditsList]);

    return next;
};
